<template>
  <div class="MembersOnlyTag member-icon">
    会员专属
    <i class="icon_member-box">
      <i class="icon_member"></i>
    </i>
  </div>
</template>

<script>
export default {
  name: "MembersOnlyTag"
}
</script>

<style lang="scss" scoped>
.member-icon {
  width: 90px;
  height: 26px;
  background: linear-gradient(303deg, #FFC04D 0%, #FFF1A4 100%);
  border-radius: 12px;
  //@include Position(1, 5, 14px, 14px);
  position: absolute;
  z-index: 10;
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #A45F00;
  padding-left: 7px;
  box-sizing: border-box;

  .icon_member-box {
    width: 26px;
    height: 26px;
    background: linear-gradient(133deg, #40456B 0%, #292C42 100%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 4px;
    border-radius: 50%;
    @include Position(1, 2, 0, 50%);
    transform: translateY(-50%);

    i {
      @include BgImage(14px, 14px, 'fans/demand-pool/vip3.svg');
    }
  }
}
</style>
